import { FormikProvider, useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { useSnackbar } from 'notistack';

// material
import { Stack, TextField } from '@mui/material';
import { LoadingButton } from '@mui/lab';

import { createWithURLSearchParams } from '../../../fetch';
import { useTranslation } from '../../../common/LocalizationProvider';

// ----------------------------------------------------------------------

export default function ForgotPasswordForm() {
  const t = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const ForgotPasswordSchema = Yup.object().shape({
    email: Yup.string().email(t('RGF_Email_Required')).required(t('RGF_Email_Required'))
  });

  const formik = useFormik({
    initialValues: {
      email: ''
    },
    validationSchema: ForgotPasswordSchema,
    onSubmit: async (values) => {
      const response = await createWithURLSearchParams(
        'password/reset',
        `email=${values.email}&forgot=${true}`,
        'POST'
      );

      if (response.ok) {
        enqueueSnackbar(t('RGF_Success'), {
          variant: 'success'
        });

        navigate('/login', { replace: true });
      } else {
        setErrors({
          email: t('FPF_Invalid_Email')
        });
        enqueueSnackbar(t('FPF_Invalid_Email'), {
          variant: 'error'
        });
      }
    }
  });

  const { errors, touched, handleSubmit, isSubmitting, getFieldProps, setErrors } = formik;

  return (
    <FormikProvider value={formik}>
      <Stack spacing={3}>
        <TextField
          fullWidth
          autoComplete="username"
          type="email"
          label={t('fields_Email')}
          {...getFieldProps('email')}
          error={Boolean(touched.email && errors.email)}
          helperText={touched.email && errors.email}
        />

        <LoadingButton
          fullWidth
          size="large"
          type="submit"
          variant="contained"
          loading={isSubmitting}
          onClick={handleSubmit}
        >
          {t('RGF_Submit')}
        </LoadingButton>
      </Stack>
    </FormikProvider>
  );
}
